<script lang="ts">
	import type { PostFiltersSchema } from '$src/utils/api/feed.util';
	import InputMain from '$lib/components/common/inputs/textInputs/GlobalTextInput.svelte';

  export let detail: PostFiltersSchema['collaborators'] = { nCollaborators: 1 };
  export let isValid: boolean;

  let _nContributors: string;

  if (detail.nCollaborators) {
    _nContributors = detail.nCollaborators.toString();
  }

  $: detail.nCollaborators = +_nContributors;
  $: isValid = detail.nCollaborators > 0;
</script>

<InputMain
  label="Contributors"
  bind:value={_nContributors}
  caption="Number of contributors"
  danger={!isValid}
  dangerMessage="No. of contributores must be greater than zero"
/>
